var _linearGradient, _linearGradient2, _style;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    id: "svg24",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs28"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient15340"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#533f0c",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop15336"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#daa520",
      stopOpacity: 0
    },
    offset: 1,
    id: "stop15338"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath15295"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e6a520",
      fillOpacity: 0,
      stroke: "#000000",
      strokeWidth: 0.0909546,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "rect15297",
    width: 28.847805,
    height: 19.717791,
    x: -68.34079,
    y: 22.726177,
    transform: "rotate(-119.58994)"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient15340",
    id: "linearGradient15342",
    x1: 48.846027,
    y1: 34.295609,
    x2: 62.699722,
    y2: 26.90029,
    gradientUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath16362"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000000",
      fill: "#daa520",
      stroke: "#000000",
      strokeWidth: 0.0952568,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m -46.372887,0.78529946 c 0,0 -0.344354,-6.16129526 -5.009842,-11.06138946 -3.357715,-3.526558 -8.766822,-5.057607 -14.926391,-4.053589 -6.159569,1.004015 -12.723935,5.5554822 -15.996358,14.5994267 -0.05014,0.13858119 -0.09972,0.27822837 -0.148558,0.41903158 l 7.55995,2.62276492 c 0.03722,-0.1073264 0.07502,-0.2140826 0.113056,-0.319227 2.47625,-6.8435686 6.163833,-8.8403553 9.758542,-9.4262949 5.609876,-0.6834993 11.520429,1.9897755 12.623224,7.474462 z",
    id: "path16364"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient15340",
    id: "linearGradient16575",
    gradientUnits: "userSpaceOnUse",
    x1: -46.372887,
    y1: 0.78529948,
    x2: -72.624123,
    y2: -13.133694
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style171"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#9835D1;}\n\t.st1{fill:none;stroke:#9835D1;stroke-width:4;stroke-miterlimit:10;}\n\t.st2{fill:#9835D1;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "g17061",
    transform: "matrix(-0.9610952,0.08622705,-0.08622705,-0.9610952,79.59432,59.833596)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M 80.693455,21.665574 C 70.877909,28.53303 69.509683,49.363946 68.149445,59.234009 53.573429,56.933878 66.503432,39.312924 47.957992,36.659436 31.030309,34.237872 14.173085,38.646232 4.7926079,19.866685 3.6393518,17.557857 4.2796589,12.037562 11.32078,11.88856 28.862455,11.517936 55.757654,8.4445267 61.167776,5.2409077 c 0,0 13.278086,-4.45298849 22.19989,-12.6357065",
    fill: "#57331f",
    id: "path18",
    style: {
      fill: "#c07750",
      fillOpacity: 1,
      strokeWidth: 6.88461
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g17130"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g17088",
    transform: "rotate(-3.7860199,24.217679,20.084572)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000000",
      fill: "#daa520",
      stroke: "#000000",
      strokeWidth: 0.095257,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 23.581313,39.937239 c 0,0 -5.187711,3.341825 -7.144976,9.818461 -1.408627,4.661183 -0.06904,10.12086 3.845564,14.981335 3.914602,4.860476 11.113887,8.321262 20.594222,6.701099 0.145266,-0.02483 0.291184,-0.05067 0.437739,-0.07773 l -1.452314,-7.869087 c -0.111708,0.02063 -0.223204,0.04048 -0.333419,0.05932 C 32.354342,64.776616 28.797084,62.555953 26.512533,59.719391 23.148078,55.17865 22.554142,48.718908 26.778976,45.051658 Z",
    id: "path9491-3",
    transform: "matrix(0.64889686,-0.9365446,0.9365446,0.64889686,-23.913511,32.206776)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "url(#linearGradient16575)",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 0.0909546,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "rect15988",
    width: 52.763424,
    height: 22.223719,
    x: -90.248764,
    y: -18.004671,
    transform: "matrix(-1.1348202,-0.10181319,0.10181319,-1.1348202,-23.913511,32.206776)",
    clipPath: "url(#clipPath16362)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.103632,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 61.582565,37.729119 60.802584,37.301607",
    id: "path11282"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.103632,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 60.937098,38.840875 -0.691832,-0.41819",
    id: "path11341"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.103632,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 52.65899,46.192648 52.443113,45.464307",
    id: "path11343"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.103632,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 60.25748,39.866653 59.588255,39.406226",
    id: "path11345"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.103632,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 59.54879,40.799482 59.025289,40.38955",
    id: "path11347"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.103632,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 58.737076,41.752769 58.236337,41.380224",
    id: "path11349"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.103632,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 58.0294,42.775921 57.413035,42.210647",
    id: "path11351"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.103632,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 57.052661,43.655731 -0.49601,-0.594852",
    id: "path11353"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.103632,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 56.063223,44.500425 55.630315,43.851712",
    id: "path11355"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.0925724,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 55.036809,45.135914 54.644558,44.471623",
    id: "path11357"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.103632,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 53.879666,45.739639 53.555295,45.03846",
    id: "path11359"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.0892358,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 51.294567,45.837433 0.177136,0.672936",
    id: "path11361"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.0908303,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 50.071739,46.042741 0.06461,0.642862",
    id: "path11363"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.103632,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 48.880855,46.142969 -0.0014,0.682743",
    id: "path11367"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.0985289,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 47.670364,46.107996 47.608684,46.8125",
    id: "path11369"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.0980209,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 46.414219,45.931339 -0.156743,0.807015",
    id: "path11373"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.0942633,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 45.04944,45.723684 -0.200492,0.717868",
    id: "path11375"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.0906921,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 43.776237,45.392261 -0.282969,0.689544",
    id: "path11377"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.0943242,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 42.57551,44.895812 -0.385698,0.681787",
    id: "path11379"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.0958711,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 41.379746,44.304276 -0.47455,0.635635",
    id: "path11381"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.0990877,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 40.196259,43.66861 39.6475,44.308314",
    id: "path11383"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.103632,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 39.157275,42.806836 -0.577071,0.679306",
    id: "path11385"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.0849059,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 38.09871,41.856064 37.536707,42.42341",
    id: "path11387"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.089218,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 37.204251,40.648677 -0.673975,0.542661",
    id: "path11389"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.0965538,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 36.51849,39.391399 -0.888374,0.569928",
    id: "path11391"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.103632,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 36.150233,38.393679 -0.830274,0.28143",
    id: "path11393"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.103632,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 35.851244,37.474507 -0.831873,0.147646",
    id: "path11397"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 48.455261,25.526823 c 0.08548,0.488754 0.595893,0.729296 0.784662,1.154616 0.07001,0.157517 0.04203,0.347263 0.111965,0.504732 0.0677,0.152251 0.220984,0.254993 0.29279,0.405446 0.04534,0.09601 0.156378,0.687149 0.118442,0.838478 -0.0366,0.148009 -0.163671,0.25697 -0.245452,0.385487 -0.138669,0.218143 -0.269154,0.50206 -0.44182,0.693829 -0.288088,0.320606 -0.629583,0.450573 -0.979007,0.681832 -0.421833,0.279367 -0.884802,0.646652 -1.246136,0.936022 -0.394873,0.316292 -0.875201,0.495633 -0.251326,0.892914",
    id: "path12748"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#daa520",
      fillOpacity: 1,
      stroke: "#daa520",
      strokeWidth: 0.108534,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 35.804231,8.3497683 28.706307,8.8397547",
    id: "path4138"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g17422"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g17252",
    transform: "matrix(0.64889686,-0.9365446,0.9365446,0.64889686,-23.913511,32.206776)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000000",
      fill: "#daa520",
      stroke: "#000000",
      strokeWidth: 0.095257,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 54.61327,23.742808 c -6.076449,-1.028742 -11.5079,2.506007 -11.5079,2.506007 l 3.979032,4.94945 c 2.616642,-1.135048 6.218901,-3.150647 8.280723,-1.267479 10.99906,10.046012 -8.452692,33.821227 -2.741056,44.604952 l -8.237707,-6.83643 C 43.964288,52.482191 64.113599,47.758627 62.235578,32.631234 61.561914,27.383695 60.945117,24.501913 54.61327,23.742808 Z",
    id: "path9491"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000000",
      fill: "url(#linearGradient15342)",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 0.095257,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 54.61327,23.742808 c -6.076449,-1.028742 -11.5079,2.506007 -11.5079,2.506007 l 3.979032,4.94945 c 2.616642,-1.135048 6.218901,-3.150647 8.280723,-1.267479 10.99906,10.046012 -8.452692,33.821227 -2.741056,44.604952 l -8.237707,-6.83643 C 43.964288,52.482191 64.113599,47.758627 62.235578,32.631234 61.561914,27.383695 60.945117,24.501913 54.61327,23.742808 Z",
    id: "path9491-7",
    clipPath: "url(#clipPath15295)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.103632,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 66.849257,33.548769 1.01076,-0.619974",
    id: "path13763"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.0898543,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 65.601044,32.452511 1.006145,-0.735937",
    id: "path13765"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.0722509,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 64.443204,31.280322 65.3305,30.520791",
    id: "path13767"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.0796017,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 63.27297,29.720647 1.023573,-0.782439",
    id: "path13769"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.0901162,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 62.260237,28.211404 1.126351,-0.78244",
    id: "path13771"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.0900176,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 61.424521,26.666179 1.224298,-0.730827",
    id: "path13773"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.0794206,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 60.690491,24.639517 1.219595,-0.536256",
    id: "path13777"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.10343,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 59.958548,22.590183 61.243046,22.12163",
    id: "path13779"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.101598,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 59.413081,20.54093 1.172732,-0.409957",
    id: "path13781"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.103632,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 58.919623,18.695795 1.130305,-0.275413",
    id: "path14143"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.111895,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 58.462593,16.643164 0.701759,-0.13593",
    id: "path14145"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.089178,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 58.044309,14.75099 58.607596,14.5697",
    id: "path14147"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.103632,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 57.647213,12.870973 0.402393,-0.136537",
    id: "path14151"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.0961773,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 57.312991,11.220169 0.251815,-0.06879",
    id: "path14155"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.101141,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 57.502528,11.9894 0.253574,-0.07793",
    id: "path14155-3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.131646,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 57.916975,13.80859 0.390347,-0.08802",
    id: "path14155-3-6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g17098",
    transform: "matrix(0.64889686,-0.9365446,0.9365446,0.64889686,-23.913511,32.206776)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect2983",
    style: {
      fill: "#2c001e",
      stroke: "#2c001e",
      strokeWidth: 2.41696,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M 54.809141,41.572353 34.516251,58.076624 C 32.506092,51.662722 27.553283,43.874137 22.620543,36.094835 L 39.263474,23.120438 c 4.786624,6.751189 10.11117,12.68508 15.545667,18.451915 z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#c07750",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    id: "path6613",
    cx: 42.156128,
    cy: -45.440788,
    rx: 4.2664599,
    ry: 4.6593781,
    transform: "rotate(87.772015)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#c07750",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    id: "path6613-3",
    cx: 31.757832,
    cy: -37.164017,
    rx: 2.4033542,
    ry: 2.3139639,
    transform: "rotate(87.772015)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#c07750",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    id: "path6613-3-7",
    cx: 44.305145,
    cy: -35.856926,
    rx: 1.2846344,
    ry: 1.3994745,
    transform: "rotate(87.772015)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#c07750",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    id: "path6613-3-7-5",
    cx: 36.364407,
    cy: -26.7551,
    rx: 1.4993994,
    ry: 1.6334386,
    transform: "rotate(87.772015)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 39.850186,37.374285 c -0.428643,1.044645 -1.370869,0.443931 -2.170998,0.549306 -0.297076,0.03935 -0.613786,0.09625 -0.870524,0.235338 -0.328798,0.178286 -0.590843,0.373786 -1.030931,0.289211 C 35.67428,38.42783 35.547561,38.36406 35.472426,38.308877 35.095705,38.033169 35.146845,37.821878 34.965314,37.4951 34.67693,36.976312 34.229647,36.504274 33.7255,36.075964 33.133114,35.573099 32.534648,35.36257 32.78712,34.529926 c 0.03923,-0.129558 0.144635,-0.278339 0.220191,-0.353969 0.2545,-0.254173 0.766413,-0.467236 1.215587,-0.151247 0.418742,0.29484 0.459263,0.780401 0.680798,1.162265 0.301962,0.520205 0.681859,0.866405 1.291443,1.269752 0.659454,0.436574 1.175959,0.191113 1.659452,0.0517 0.123144,-0.03573 0.256216,-0.09192 0.36799,-0.154258 0.170993,-0.09547 0.335302,-0.224257 0.526589,-0.269414 0.09613,-0.02245 0.207547,-0.02791 0.31549,-0.01638 0.542535,0.05792 0.832983,0.622939 0.836868,0.974364 8.47e-4,0.106897 7.12e-4,0.188287 -0.05116,0.331279",
    id: "path173-6",
    style: {
      clipRule: "evenodd",
      fill: "#c07750",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0.0222142
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect12946",
    style: {
      fill: "#c07750",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 40.384478,46.043591 c 0.233797,0.135199 0.419528,0.386354 0.486811,0.647989 0.326749,1.271134 0.113889,2.768392 -0.553891,3.898233 -0.546989,0.925372 -1.537272,1.669273 -2.578378,1.936825 -1.271136,0.326747 -2.793161,0.154019 -3.898232,-0.553893 -0.757744,-0.485463 -1.470704,-1.369724 -1.462056,-2.269602 0.0086,-0.914101 0.646731,-2.037809 1.529151,-2.276614 1.279376,-0.346284 2.337037,2.194631 3.579123,1.732109 1.121507,-0.417529 0.383576,-2.701388 1.421702,-3.29663 0.430004,-0.246541 1.046756,-0.06677 1.475798,0.181601 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect14307",
    style: {
      fill: "#c07750",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 32.322044,45.321749 c -0.188522,0.65047 -1.394011,0.321049 -2.029821,0.08736 -0.804695,-0.295235 -1.429372,-1.021844 -1.887588,-1.746221 -0.865993,-1.36901 -2.660439,-5.473849 -1.453615,-4.637252 3.845315,2.665602 2.170623,-1.105709 3.245502,-0.809479 3.049697,1.90432 2.859009,4.574668 2.125495,7.105302 z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustom);
export default __webpack_public_path__ + "static/media/custom.5ad9f31b4b71685794498ae04c02130c.svg";
export { ForwardRef as ReactComponent };